import React from 'react';
import panMobile from '../assets/mobile-pan.svg';
import panDesktop from '../assets/desktop-pan.svg';
import panIcon from '../assets/pan.svg';
import zoomMobile from '../assets/mobile-zoom.svg';
import zoomDesktop from '../assets/desktop-zoom.svg';
import zoomIcon from '../assets/zoom.svg';
import rotateMobile from '../assets/mobile-rotate.svg';
import rotateDesktop from '../assets/desktop-rotate.svg';
import rotateIcon from '../assets/rotate.svg';
import useLayersStore from '../stores/layersStore';
import { useIsMobile } from '../hooks/useIsMobile';
import { X } from 'react-feather';

const InfoOverlay = () => {
    const { setInfoOverlayOpened, infoOverlayOpened } = useLayersStore();

    const isMobileDevice = useIsMobile();

    if (!infoOverlayOpened) return null;
    return (
        <div className="fixed top-0 left-0 w-screen h-screen flex flex-col justify-center items-center text-white z-50 text-center bg-black/50">
            <div>
                <div>
                    <h3 className='text-[clamp(1.5rem,5vmin,2.2rem)] font-bold uppercase'>Controls</h3>
                </div>
                    <X size={40} className='absolute right-8 top-16 cursor-pointer' onClick={() => setInfoOverlayOpened(false)}/>
            </div>
            <div className='flex'>
                <div className='flex flex-col justify-start items-center p-[2vmin]'>
                    <p className='text-[clamp(1.3rem,5vmin,1.8rem)] text-[#4bccea] uppercase'>Pan</p>
                    <img className='w-[25vmin]' src={panIcon} />
                    <img className='w-[25vmin]' src={isMobileDevice ? panMobile : panDesktop} />
                    <p className='text-[clamp(1rem,4vmin,1.5rem)]'>{ isMobileDevice ? "Touch & Drag with 2 fingers" : "Right Click & Drag" }</p>
                </div>
                <div className='flex flex-col justify-start items-center p-[2vmin]'>
                    <p className='text-[clamp(1.3rem,5vmin,1.8rem)] text-[#4bccea] uppercase'>Rotate</p>
                    <img className='w-[25vmin]' src={rotateIcon} />
                    <img className='w-[25vmin]' src={isMobileDevice ? rotateMobile : rotateDesktop} />
                    <p className='text-[clamp(1rem,4vmin,1.5rem)]'>{ isMobileDevice ? "Touch & Drag with 1 finger" : "Left Click & Drag" }</p>
                </div>
                <div className='flex flex-col justify-start items-center p-[2vmin]'>
                    <p className='text-[clamp(1.3rem,5vmin,1.8rem)] text-[#4bccea] uppercase'>Zoom</p>
                    <img className='w-[25vmin]' src={zoomIcon} />
                    <img className='w-[25vmin]' src={isMobileDevice ? zoomMobile : zoomDesktop} />
                    <p className='text-[clamp(1rem,4vmin,1.5rem)]'>{ isMobileDevice ? "Touch & Pinch with 2 fingers" : "Scroll Mouse Wheel" }</p>

                </div>
            </div>
        </div>
    )
}
export default InfoOverlay
